export const fonts: { [key: string]: string } = {
  "Lemon Milk": '"LEMON MILK Pro", Arial, sans-serif',
  "Quick Sand": '"Quicksand", sans-serif',
  QLD: '"Edu QLD Beginner", cursive',
  TAS: '"Edu TAS Beginner", cursive',
  SA: '"Edu SA Beginner", cursive',
  NSW: '"Edu NSW ACT Foundation", cursive',
};
